export default __webpack_public_path__ + "images/loans-underline.1248aa84ce437f9190ccba79f5b27660.png";